import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import RadarActionsBridge from './components/RadarActionsBridge';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <RadarActionsBridge />
  </React.StrictMode>
);
